import { forwardRef } from "react";
import { WrapperInput, Col } from "components/core";

import styled from "styled-components";

const ContainerFormatInput = styled(Col)`
  select {
    background: #e8eaf6;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 100%;
    padding: 0.6em;
  }

  label {
    color: #111;
  }

  & select:focus,
  & select:focus {
    outline: none;
  }
`;

export const Select = forwardRef(
  (
    {
      options = [],
      defaultValue = "",
      disabled = false,
      name = "",
      xs,
      md,
      classMain,
      classLabel,
      label,
      valueOption,
      labelOption,
      placeholder,
      onChange,
      onClick,
      className,
      isRequired,
      error,
    },
    ref
  ) => {
    return (
      <ContainerFormatInput xs={xs} md={md} className="p0">
        <WrapperInput
          classMain={classMain}
          classLabel={classLabel}
          label={label}
        >
          <select
            name={name}
            ref={ref}
            disabled={disabled}
            placeholder={placeholder}
            defaultValue={defaultValue}
            onChange={onChange}
            onClick={onClick}
            className={className}
            required={isRequired}
          >
            {options.map((item) => {
              return (
                <option key={item[valueOption]} value={item[valueOption]}>
                  {item[labelOption] || ""}
                </option>
              );
            })}
          </select>
          {error && <small className="red">{error}</small>}
        </WrapperInput>
      </ContainerFormatInput>
    );
  }
);
